import gql from 'graphql-tag'

export const gqlGetVehiclesCategory = gql`
  query consultaCategorias($categoria: String!) {
    consultaCategorias(categoria: $categoria) {
      descricao
      id
    }
  }
`

export const gqlActivateIdentification = gql`
  mutation identificadorAtivar(
    $placa: String!
    $categoria: String!
    $id: String!
    $tipoProduto: String!
    $codIdentificador: String!
    $tipoIdentificador: String!
  ) {
    identificadorAtivar(
      identificador: {
        veiculo: { placa: $placa, categoria: $categoria }
        clienteConta: { conta: { id: $id, tipoProduto: $tipoProduto } }
        codIdentificador: $codIdentificador
        tipoIdentificador: $tipoIdentificador
      }
    ) {
      result {
        idConta
        nomeUsuario
      }
      error {
        codigo
        message
      }
    }
  }
`

export const gqlNewIdentifier = gql`
  mutation identificadorAdquirir(
    $quantidadeIdentificadores: Int!
    $endereco: EnderecoIdentificadorInput
    $id: String!
  ) {
    identificadorAdquirir(
      adquirirIdentificador: {
        quantidadeIdentificadores: $quantidadeIdentificadores
        endereco: $endereco
        codigoCliente: { conta: { id: $id } }
      }
    ) {
      result
      error {
        message
      }
    }
  }
`

export const gqlIdentificadores = gql`
  query identificadoresPJ($idConta: String!) {
    identificadoresPJ(idConta: $idConta) {
      idIdentificador
      codIdentificador
      tipoIdentificador
      informacoesGerenciais {
        tipoInfo
        descricaoAtual
      }
      veiculo {
        marca
        modelo
        placa
        chassi
        renavam
        categoria
        tipo
      }
      situacao
      dataAtualizacao
    }
  }
`

export const gqlIdentificadoresPaginado = gql`
  query identificadoresPJV2(
    $idConta: String!
    $placa: String
    $identificador: String
    $gerencial: Boolean
    $pagina: Int
    $quantidade: Int
    $ordenacao: String
    $somentePlacas: Boolean
  ) {
    identificadoresPJV2(
      idConta: $idConta
      placa: $placa
      identificador: $identificador
      gerencial: $gerencial
      pagina: $pagina
      quantidade: $quantidade
      ordenacao: $ordenacao
      somentePlacas: $somentePlacas
    ) {
      identificadores {
        idIdentificador
        codIdentificador
        tipoIdentificador
        informacoesGerenciais {
          tipoInfo
          descricaoAtual
        }
        veiculo {
          marca
          modelo
          placa
          chassi
          renavam
          categoria
          tipo
        }
        situacao
        dataAtualizacao
        pap
      }
      paginacao {
        pagina
        quantidade
        total
        proxima
        anterior
      }
    }
  }
`

export const gqlHistoricoIdentificadorTag = gql`
  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {
    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {
      id
      pap
      placa
      historicos {
        codIdentificador
        dataInclusao
        operacao
        placa
      }
    }
  }
`

export const gqlTotalIdentificadores = gql`
  query totalIdentificadores($idConta: String!) {
    identificadoresPJV2(idConta: $idConta, ativos: true) {
      paginacao {
        total
      }
    }
  }
`

export const gqlIdentificador = gql`
  query identificador($numero: String!) {
    identificador(numero: $numero) {
      idIdentificador
      codIdentificador
      tipoIdentificador
      veiculo {
        marca
        modelo
        placa
        chassi
        renavam
        categoria
        tipo
      }
      situacao
      dataAtualizacao
    }
  }
`

export const gqlDesabilitarIdentificador = gql`
  mutation identificadorInativar(
    $quantidadeIdentificadores: Int!
    $codigoIdentificador: String!
    $motivoInativacaoIdentificador: String!
    $motivoInativacaoIdentificadorDescricao: String
    $id: String!
  ) {
    identificadorInativar(
      inativarIdentificador: {
        quantidadeIdentificadores: $quantidadeIdentificadores
        codigoIdentificador: $codigoIdentificador
        motivoInativacaoIdentificador: $motivoInativacaoIdentificador
        motivoInativacaoIdentificadorDescricao: $motivoInativacaoIdentificadorDescricao
        codigoCliente: { conta: { id: $id } }
      }
    ) {
      result
      error {
        message
      }
    }
  }
`

export const gqlSubstituirIdentificador = gql`
  mutation identificadorSubstituir(
    $codigoConta: String!
    $codigoIdentificador: String
    $motivoInativacao: String
    $motivoDescricao: String
    $novoCodigo: String
    $cep: String
    $logradouro: String
    $numero: String
    $complemento: String
    $bairro: String
    $uf: String
    $cidade: String
  ) {
    identificadorSubstituir(
      substituirIdentificador: {
        codigoCliente: { conta: { id: $codigoConta, tipoProduto: "POS" } }
        codigoIdentificador: $codigoIdentificador
        motivoInativacaoIdentificador: $motivoInativacao
        motivoInativacaoIdentificadorDescricao: $motivoDescricao
        novoCodigoIdentificador: $novoCodigo
        endereco: {
          cep: $cep
          logradouro: $logradouro
          numero: $numero
          complemento: $complemento
          bairro: $bairro
          uf: $uf
          cidade: $cidade
        }
      }
    ) {
      result
      error {
        codigo
        message
      }
    }
  }
`

export const gqlModificarPapIndividual = gql`
  mutation mudarSituacaoPapIndividual(
    $idConta: String!
    $adesaoPap: Boolean
    $identificador: String
    $placa: String
  ) {
    mudarSituacaoPapIndividual(
      idConta: $idConta
      adesaoPap: $adesaoPap
      identificador: $identificador
      placa: $placa
    ) {
      adesaoPap
    }
  }
`
export const gqlDownloadIdentificadoresCsv = gql`
  query consultarIdentificadoresAtivos($idConta: String!) {
    consultarIdentificadoresAtivos(idConta: $idConta)
  }
`

export const transformIndentificadoresPaginado = src => {
  const { identificadoresPJV2: { identificadores, paginacao } } = src.data
  return (
    identificadores &&
    identificadores.map(
      ({ 'id-conta': idConta, 'id-cliente': idCliente, ...rest }) => ({
        ...rest,
        idConta,
        idCliente
      }),
      paginacao
    )
  )
}

export const transformIndentificadores = src => {
  const { identificadoresPJ } = src.data
  return (
    identificadoresPJ &&
    identificadoresPJ.map(({ 'id-conta': idConta, 'id-cliente': idCliente, ...rest }) => ({
      ...rest,
      idConta,
      idCliente
    }))
  )
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/vehicles.js